//*
// Do not edit directly
// Generated from Furry Design System
//

export const DewiRadiusRounded = '62.5rem'
export const DewiRadius2xl = '1.75rem'
export const DewiRadiusXl = '1.375rem'
export const DewiRadiusMd = '0.75rem'
export const DewiRadiusSm = '0.625rem'
export const DewiRadiusLg = '1rem'
export const DewiRadiusXs = '0.25rem'
export const DewiRadiusNone = '0'
export const DewiBreakpoints2xl = '1440'
export const DewiBreakpointsMd = '600'
export const DewiBreakpointsXs = '300'
export const DewiBreakpointsLg = '900'
export const DewiBreakpointsSm = '400'
export const DewiBreakpointsXl = '1300'
export const DewiSpacing0 = '0'
export const DewiSpacing1 = '0.25rem'
export const DewiSpacing2 = '0.5rem'
export const DewiSpacing3 = '0.75rem'
export const DewiSpacing4 = '1rem'
export const DewiSpacing5 = '1.25rem'
export const DewiSpacing6 = '1.5rem'
export const DewiSpacing7 = '1.75rem'
export const DewiSpacing8 = '2rem'
export const DewiSpacing9 = '2.25rem'
export const DewiSpacing10 = '2.5rem'
export const DewiSpacing11 = '2.75rem'
export const DewiSpacing12 = '3rem'
export const DewiSpacing14 = '3.5rem'
export const DewiSpacing16 = '4rem'
export const DewiSpacing20 = '5rem'
export const DewiSpacing24 = '6rem'
export const DewiSpacing28 = '7rem'
export const DewiSpacing30 = '7.5rem'
export const DewiSpacing32 = '8rem'
export const DewiSpacing36 = '9rem'
export const DewiSpacing40 = '10rem'
export const DewiSpacing48 = '12rem'
export const DewiSpacing52 = '13rem'
export const DewiSpacing56 = '14rem'
export const DewiSpacing60 = '15rem'
export const DewiSpacing64 = '16rem'
export const DewiSpacing72 = '18rem'
export const DewiSpacing80 = '20rem'
export const DewiSpacing96 = '24rem'
export const DewiSpacing25 = '0.625rem'
export const DewiSpacing025 = '0.0625rem'
export const DewiSpacing05 = '0.125rem'
export const DewiColorsStatesDestructiveActive = 'hsl(3, 75%, 63%)'
export const DewiColorsStatesDestructiveSelected = 'hsl(2, 78%, 68%)'
export const DewiColorsStatesDestructiveHover = 'hsl(2, 76%, 74%)'
export const DewiColorsStatesHighlight = '#ffffff'
export const DewiColorsStatesSuccess = '#66bb62'
export const DewiColorsStatesActive = '#ffffff'
export const DewiColorsStatesHover = '#d4d4d4'
export const DewiColorsStatesSelected = '#3d3d3d'
export const DewiColorsStatesFocus = '#3d3d3d'
export const DewiColorsYellow0 = '#fef9de'
export const DewiColorsYellow1 = '#fdf3c5'
export const DewiColorsYellow2 = '#fceda3'
export const DewiColorsYellow3 = '#fae179'
export const DewiColorsYellow4 = '#f8d65b'
export const DewiColorsYellow5 = '#ffffff'
export const DewiColorsYellow6 = '#edb13f'
export const DewiColorsYellow7 = '#e9a339'
export const DewiColorsYellow8 = '#e29134'
export const DewiColorsYellow9 = '#d87d2e'
export const DewiColorsViolet0 = '#f2f0fe'
export const DewiColorsViolet1 = '#e3dbfc'
export const DewiColorsViolet2 = '#cdc0fa'
export const DewiColorsViolet3 = '#ad98f5'
export const DewiColorsViolet4 = '#9276f2'
export const DewiColorsViolet5 = '#7e60ee'
export const DewiColorsViolet6 = '#7352e9'
export const DewiColorsViolet7 = '#6a4ae0'
export const DewiColorsViolet8 = '#6243d1'
export const DewiColorsViolet9 = '#5a3ebd'
export const DewiColorsTeal0 = '#eafbf5'
export const DewiColorsTeal1 = '#cef8e9'
export const DewiColorsTeal2 = '#abf0d8'
export const DewiColorsTeal3 = '#87e3c0'
export const DewiColorsTeal4 = '#6ed6ac'
export const DewiColorsTeal5 = '#5fc69a'
export const DewiColorsTeal6 = '#55b589'
export const DewiColorsTeal7 = '#4ba47b'
export const DewiColorsTeal8 = '#41906b'
export const DewiColorsTeal9 = '#387d5d'
export const DewiColorsRed0 = '#fdf5f5'
export const DewiColorsRed1 = '#fae4e3'
export const DewiColorsRed2 = '#f7cbca'
export const DewiColorsRed3 = '#f3acaa'
export const DewiColorsRed4 = '#ef8d8a'
export const DewiColorsRed5 = '#ed7470'
export const DewiColorsRed6 = '#e75f59'
export const DewiColorsRed7 = '#dd4e47'
export const DewiColorsRed8 = '#ce423a'
export const DewiColorsRed9 = '#b93a33'
export const DewiColorsPink0 = '#fcf1f6'
export const DewiColorsPink1 = '#fadfea'
export const DewiColorsPink2 = '#f3c4d6'
export const DewiColorsPink3 = '#eda6c0'
export const DewiColorsPink4 = '#e889ab'
export const DewiColorsPink5 = '#df6e94'
export const DewiColorsPink6 = '#d55580'
export const DewiColorsPink7 = '#c5426c'
export const DewiColorsPink8 = '#b2355c'
export const DewiColorsPink9 = '#982c4d'
export const DewiColorsOrange0 = '#fdf4e7'
export const DewiColorsOrange1 = '#fbe9cf'
export const DewiColorsOrange2 = '#f9d9ae'
export const DewiColorsOrange3 = '#f5c383'
export const DewiColorsOrange4 = '#f3ad5f'
export const DewiColorsOrange5 = '#f09745'
export const DewiColorsOrange6 = '#ed8537'
export const DewiColorsOrange7 = '#e6702e'
export const DewiColorsOrange8 = '#d7622b'
export const DewiColorsOrange9 = '#c95328'
export const DewiColorsLime0 = '#f5fce5'
export const DewiColorsLime1 = '#ecf9cd'
export const DewiColorsLime2 = '#def4ab'
export const DewiColorsLime3 = '#c9ea84'
export const DewiColorsLime4 = '#b5e164'
export const DewiColorsLime5 = '#a3d64f'
export const DewiColorsLime6 = '#92c744'
export const DewiColorsLime7 = '#83b63c'
export const DewiColorsLime8 = '#75a635'
export const DewiColorsLime9 = '#69932e'
export const DewiColorsIndigo0 = '#eef2fe'
export const DewiColorsIndigo1 = '#dde4fd'
export const DewiColorsIndigo2 = '#bdc8fb'
export const DewiColorsIndigo3 = '#95a6f9'
export const DewiColorsIndigo4 = '#798ef5'
export const DewiColorsIndigo5 = '#637bf2'
export const DewiColorsIndigo6 = '#536ded'
export const DewiColorsIndigo7 = '#4962e3'
export const DewiColorsIndigo8 = '#425ad3'
export const DewiColorsIndigo9 = '#3b4ec0'
export const DewiColorsGreen0 = '#eefaef'
export const DewiColorsGreen1 = '#daf8db'
export const DewiColorsGreen2 = '#bff0c0'
export const DewiColorsGreen3 = '#a2e7a1'
export const DewiColorsGreen4 = '#87d886'
export const DewiColorsGreen5 = '#ffffff'
export const DewiColorsGreen6 = '#66bb62'
export const DewiColorsGreen7 = '#5daf59'
export const DewiColorsGreen8 = '#529c4f'
export const DewiColorsGreen9 = '#488847'
export const DewiColorsGray0 = '#ffffff'
export const DewiColorsGray1 = '#f5f5f5'
export const DewiColorsGray2 = '#e5e5e5'
export const DewiColorsGray3 = '#d4d4d4'
export const DewiColorsGray4 = '#c7c7c7'
export const DewiColorsGray5 = '#b3b3b3'
export const DewiColorsGray6 = '#a3a3a3'
export const DewiColorsGray7 = '#404040'
export const DewiColorsGray8 = '#262626'
export const DewiColorsGray9 = '#171717'
export const DewiColorsGrape0 = '#f7f0fb'
export const DewiColorsGrape1 = '#efdaf8'
export const DewiColorsGrape2 = '#e6c0f6'
export const DewiColorsGrape3 = '#da9cf1'
export const DewiColorsGrape4 = '#cd7ceb'
export const DewiColorsGrape5 = '#be63e1'
export const DewiColorsGrape6 = '#b052d4'
export const DewiColorsGrape7 = '#a146c2'
export const DewiColorsGrape8 = '#903daf'
export const DewiColorsGrape9 = '#7c3497'
export const DewiColorsDark0 = '#e5e5e5'
export const DewiColorsDark1 = '#d4d4d4'
export const DewiColorsDark2 = '#a3a3a3'
export const DewiColorsDark3 = '#737373'
export const DewiColorsDark4 = '#2e2e2e'
export const DewiColorsDark5 = '#262626'
export const DewiColorsDark6 = '#1f1f1f'
export const DewiColorsDark7 = '#1a1a1a'
export const DewiColorsDark8 = '#121212'
export const DewiColorsDark9 = '#000000'
export const DewiColorsCyan0 = '#e7f9fb'
export const DewiColorsCyan1 = '#cff5f9'
export const DewiColorsCyan2 = '#abe7f0'
export const DewiColorsCyan3 = '#84d6e5'
export const DewiColorsCyan4 = '#68c6d8'
export const DewiColorsCyan5 = '#ffffff'
export const DewiColorsCyan6 = '#4fa7bc'
export const DewiColorsCyan7 = '#4596aa'
export const DewiColorsCyan8 = '#3c8396'
export const DewiColorsCyan9 = '#337083'
export const DewiColorsBlue0 = '#f5f5f5'
export const DewiColorsBlue1 = '#e5e5e5'
export const DewiColorsBlue2 = '#d4d4d4'
export const DewiColorsBlue3 = '#b3b3b3'
export const DewiColorsBlue4 = '#8f8f8f'
export const DewiColorsBlue5 = '#737373'
export const DewiColorsBlue6 = '#ffffff'
export const DewiColorsBlue7 = '#525252'
export const DewiColorsBlue8 = '#404040'
export const DewiColorsBlue9 = '#333333'
export const DewiFontFamiliesInter = 'Inter'
export const DewiLineHeights0 = '1rem'
export const DewiLineHeights1 = '1.375rem'
export const DewiLineHeights2 = '1.5rem'
export const DewiLineHeights3 = '1.875rem'
export const DewiLineHeights4 = '2rem'
export const DewiLineHeights5 = '2.125rem'
export const DewiLineHeights6 = '2.625rem'
export const DewiLineHeights7 = '3rem'
export const DewiLineHeights8 = '3.625rem'
export const DewiLineHeights9 = '5.375rem'
export const DewiLineHeights10 = '6.75rem'
export const DewiLineHeights11 = '9rem'
export const DewiLineHeights12 = '12rem'
export const DewiFontSize0 = '0.75rem'
export const DewiFontSize1 = '0.875rem'
export const DewiFontSize2 = '1rem'
export const DewiFontSize3 = '1.125rem'
export const DewiFontSize4 = '1.25rem'
export const DewiFontSize5 = '1.5rem'
export const DewiFontSize6 = '1.875rem'
export const DewiFontSize7 = '2.25rem'
export const DewiFontSize8 = '3rem'
export const DewiFontSize9 = '3.75rem'
export const DewiFontSize10 = '4.5rem'
export const DewiFontSize11 = '6rem'
export const DewiFontSize12 = '8rem'
export const DewiLetterSpacing0 = '0'
export const DewiParagraphSpacing0 = '0'
